import * as types from './mutation_types'

export default {
  [types.RESET] (state) {
    Object.assign(state, {
      error: '',
      isLoading: false,
      retrieved: null,
      updated: null,
      violations: null
    })
  },

  [types.SET_ERROR] (state, error) {
    Object.assign(state, { error })
  },

  [types.TOGGLE_LOADING] (state) {
    Object.assign(state, { isLoading: !state.isLoading })
  },

  [types.SET_RETRIEVED] (state, retrieved) {
    retrieved.allowedAccessRole.forEach(client => {
      const permissions = client.permissions
      const updateIndex = permissions.findIndex(perm => perm.text === 'update')
      // Sprawdź, czy istnieje uprawnienie "take"
      const takeExists = permissions.some(perm => perm.text === 'take')
      if (!takeExists && updateIndex !== -1) {
        // Utwórz nowe uprawnienie "take" z wartością taką jak "update"
        const takePermission = {
          value: permissions[updateIndex].value,
          text: 'take'
        }
        // Wstaw uprawnienie "take" bezpośrednio po "update"
        permissions.splice(updateIndex + 1, 0, takePermission)
      }
    })

    Object.assign(state, { retrieved })
  },

  [types.SET_UPDATED] (state, updated) {
    Object.assign(state, { error: '', updated, violations: null })
  },

  [types.SET_VIOLATIONS] (state, violations) {
    Object.assign(state, { violations })
  },

  [types.UPDATE_RETRIEVED] (state, updated) {
    Object.assign(state.retrieved, updated)
  }
}
